// Use a relative import for `lib/config` (not the `@/lib/config` path alias):
// next.config.ts loads this file via Next's TS-config compilation pipeline,
// and the compiled `next.config.compiled.js` rewrites `@/` to `./`, which
// resolves wrongly when followed from this file's directory and breaks
// `bun run dev` and `bun run build` with MODULE_NOT_FOUND.

import type { AppEnv } from "../app-env";
import { getConfig } from "../config";

export const SENTRY_REPORTING_ENVS = ["stage-v2", "prod-v2"] as const;

export function isSentryReportingEnabled(env?: AppEnv): boolean {
  // Explicit env arg short-circuits the config lookup so tests can assert
  // per-env behavior without mutating process.env.
  if (env !== undefined) {
    return env === "stage-v2" || env === "prod-v2";
  }
  return getConfig().features.enableSentry;
}
